module.exports = __webpack_public_path__ + "static/img/screenshot.fc15c93c.png";